import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../Auth.css';
import { login } from '../api/auth';

const PHONE_REGEX = /^1\d{10}$/;

function LoginPage() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    if (!PHONE_REGEX.test(phone)) {
      setError('请输入正确的手机号码');
      return;
    }
    if (!password) {
      setError('请输入密码');
      return;
    }

    setLoading(true);
    try {
      // 调用后端登录API
      const response = await login(phone, password);
      
      // 存储JWT token
      localStorage.setItem('lda_auth_token', response.access_token);
      
      setSuccess('登录成功，正在跳转...');
      setTimeout(() => navigate('/'), 300);
    } catch (error) {
      console.error('登录失败:', error);
      if (error.response?.data?.detail) {
        setError(error.response.data.detail);
      } else {
        setError('登录失败，请稍后重试');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-shell">
        <section className="auth-hero">
          <div>
            <div className="logo">
              <i className="fas fa-robot"></i>
              <span>湾小通</span>
            </div>
            <h1 className="auth-hero-title">欢迎回来</h1>
            <p className="auth-hero-subtitle">使用 LDA 主题建模进行智能文本分析</p>
          </div>
          <div className="auth-hero-points">
            <span><span className="auth-dot"></span>智能主题提取</span>
            <span><span className="auth-dot"></span>可视化分析报告</span>
            <span><span className="auth-dot"></span>AI 智能解读</span>
          </div>
        </section>

        <section className="auth-card">
          <div>
            <span className="auth-badge">登录</span>
            <h2 className="auth-title">账户登录</h2>
            <p className="auth-subtitle">请输入您的手机号和密码登录 LDA 平台</p>
          </div>

          {error && <div className="auth-alert auth-alert-error">{error}</div>}
          {success && <div className="auth-alert auth-alert-success">{success}</div>}

          <form className="auth-form" onSubmit={handleSubmit}>
            <label className="auth-field">
              手机号
              <input
                className="auth-input"
                type="tel"
                placeholder="请输入11位手机号"
                value={phone}
                onChange={(event) => setPhone(event.target.value.trim())}
                autoComplete="tel"
              />
            </label>
            <label className="auth-field">
              密码
              <input
                className="auth-input"
                type="password"
                placeholder="请输入密码"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete="current-password"
              />
            </label>
            <button className="auth-button" type="submit" disabled={loading}>
              {loading ? '登录中...' : '登录'}
            </button>
          </form>

          <div className="auth-footer">
            <span>还没有账号？</span>
            <Link className="auth-link" to="/register">立即注册</Link>
          </div>
          <div className="auth-note">提示：首次使用请先注册账号</div>
        </section>
      </div>
    </div>
  );
}

export default LoginPage;
